// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-container {
    min-height: 100vh;
    background: linear-gradient(to bottom, #f0f7ff, #e6f2ff);
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 20px;
  }
  
  .login-header {
    text-align: center;
    margin-bottom: 30px;
  }
  
  .logo {
    font-size: 3rem;
    font-weight: bold;
    color: #1a3a6c;
    margin-bottom: 10px;
  }
  
  .logo-highlight {
    color: #f59e0b;
  }
  
  .login-header h2 {
    font-size: 1.8rem;
    color: #1e293b;
    margin: 10px 0;
  }
  
  .login-header p {
    color: #475569;
    font-size: 1rem;
  }
  
  .login-card {
    background: white;
    border-radius: 12px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
    padding: 30px;
    max-width: 450px;
    margin: 0 auto;
    width: 100%;
  }
  
  .error-message {
    background: #fee2e2;
    color: #b91c1c;
    padding: 12px;
    border-radius: 8px;
    margin-bottom: 20px;
    font-size: 0.9rem;
  }
  
  .form-group {
    margin-bottom: 20px;
  }
  
  .form-group label {
    display: block;
    font-weight: 500;
    color: #334155;
    margin-bottom: 6px;
  }
  
  .form-group input {
    width: 100%;
    padding: 12px 15px;
    border: 1px solid #cbd5e1;
    border-radius: 8px;
    font-size: 1rem;
    transition: border-color 0.3s;
  }
  
  .form-group input:focus {
    outline: none;
    border-color: #3b82f6;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.2);
  }
  
  .form-footer {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 20px;
  }
  
  .form-footer a {
    color: #3b82f6;
    font-size: 0.9rem;
    text-decoration: none;
  }
  
  .form-footer a:hover {
    text-decoration: underline;
  }
  
  .submit-btn {
    width: 100%;
    background: #1d4ed8;
    color: white;
    border: none;
    padding: 14px;
    border-radius: 8px;
    font-size: 1rem;
    font-weight: 600;
    cursor: pointer;
    transition: background 0.3s;
  }
  
  .submit-btn:hover {
    background: #1e40af;
  }
  
  .submit-btn:disabled {
    opacity: 0.7;
    cursor: not-allowed;
  }
  
  .divider {
    position: relative;
    margin: 25px 0;
  }
  
  .divider::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 0;
    right: 0;
    height: 1px;
    background: #e2e8f0;
    transform: translateY(-50%);
  }
  
  .divider span {
    position: relative;
    padding: 0 10px;
    background: white;
    color: #64748b;
    font-size: 0.9rem;
  }
  
  .signup-link {
    text-align: center;
    color: #64748b;
    font-size: 0.95rem;
  }
  
  .signup-link a {
    color: #3b82f6;
    font-weight: 500;
    text-decoration: none;
  }
  
  .signup-link a:hover {
    text-decoration: underline;
  }

  `, "",{"version":3,"sources":["webpack://./src/pages/Login.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,wDAAwD;IACxD,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,iBAAiB;IACjB,cAAc;IACd,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;IACnB,0CAA0C;IAC1C,aAAa;IACb,gBAAgB;IAChB,cAAc;IACd,WAAW;EACb;;EAEA;IACE,mBAAmB;IACnB,cAAc;IACd,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,gBAAgB;IAChB,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,6BAA6B;EAC/B;;EAEA;IACE,aAAa;IACb,qBAAqB;IACrB,6CAA6C;EAC/C;;EAEA;IACE,aAAa;IACb,yBAAyB;IACzB,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,iBAAiB;IACjB,qBAAqB;EACvB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,WAAW;IACX,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,2BAA2B;EAC7B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,OAAO;IACP,QAAQ;IACR,WAAW;IACX,mBAAmB;IACnB,2BAA2B;EAC7B;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,cAAc;IACd,gBAAgB;IAChB,qBAAqB;EACvB;;EAEA;IACE,0BAA0B;EAC5B","sourcesContent":[".login-container {\n    min-height: 100vh;\n    background: linear-gradient(to bottom, #f0f7ff, #e6f2ff);\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    padding: 20px;\n  }\n  \n  .login-header {\n    text-align: center;\n    margin-bottom: 30px;\n  }\n  \n  .logo {\n    font-size: 3rem;\n    font-weight: bold;\n    color: #1a3a6c;\n    margin-bottom: 10px;\n  }\n  \n  .logo-highlight {\n    color: #f59e0b;\n  }\n  \n  .login-header h2 {\n    font-size: 1.8rem;\n    color: #1e293b;\n    margin: 10px 0;\n  }\n  \n  .login-header p {\n    color: #475569;\n    font-size: 1rem;\n  }\n  \n  .login-card {\n    background: white;\n    border-radius: 12px;\n    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);\n    padding: 30px;\n    max-width: 450px;\n    margin: 0 auto;\n    width: 100%;\n  }\n  \n  .error-message {\n    background: #fee2e2;\n    color: #b91c1c;\n    padding: 12px;\n    border-radius: 8px;\n    margin-bottom: 20px;\n    font-size: 0.9rem;\n  }\n  \n  .form-group {\n    margin-bottom: 20px;\n  }\n  \n  .form-group label {\n    display: block;\n    font-weight: 500;\n    color: #334155;\n    margin-bottom: 6px;\n  }\n  \n  .form-group input {\n    width: 100%;\n    padding: 12px 15px;\n    border: 1px solid #cbd5e1;\n    border-radius: 8px;\n    font-size: 1rem;\n    transition: border-color 0.3s;\n  }\n  \n  .form-group input:focus {\n    outline: none;\n    border-color: #3b82f6;\n    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.2);\n  }\n  \n  .form-footer {\n    display: flex;\n    justify-content: flex-end;\n    margin-bottom: 20px;\n  }\n  \n  .form-footer a {\n    color: #3b82f6;\n    font-size: 0.9rem;\n    text-decoration: none;\n  }\n  \n  .form-footer a:hover {\n    text-decoration: underline;\n  }\n  \n  .submit-btn {\n    width: 100%;\n    background: #1d4ed8;\n    color: white;\n    border: none;\n    padding: 14px;\n    border-radius: 8px;\n    font-size: 1rem;\n    font-weight: 600;\n    cursor: pointer;\n    transition: background 0.3s;\n  }\n  \n  .submit-btn:hover {\n    background: #1e40af;\n  }\n  \n  .submit-btn:disabled {\n    opacity: 0.7;\n    cursor: not-allowed;\n  }\n  \n  .divider {\n    position: relative;\n    margin: 25px 0;\n  }\n  \n  .divider::before {\n    content: '';\n    position: absolute;\n    top: 50%;\n    left: 0;\n    right: 0;\n    height: 1px;\n    background: #e2e8f0;\n    transform: translateY(-50%);\n  }\n  \n  .divider span {\n    position: relative;\n    padding: 0 10px;\n    background: white;\n    color: #64748b;\n    font-size: 0.9rem;\n  }\n  \n  .signup-link {\n    text-align: center;\n    color: #64748b;\n    font-size: 0.95rem;\n  }\n  \n  .signup-link a {\n    color: #3b82f6;\n    font-weight: 500;\n    text-decoration: none;\n  }\n  \n  .signup-link a:hover {\n    text-decoration: underline;\n  }\n\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
